import { Link } from "gatsby"
import Hel from "@onestore/hel/dist/Hel"
import { default as strefaTheme } from "@onestore/hel/dist/theme/strefa"
import { ThemeProvider } from "@ionos-web-design-system/react"
import "./styles.css"

export const wrapPageElement = ({ element }) => (
  <Hel brand="strefa" env="production" theme={strefaTheme} linkComponent={Link}>
    <ThemeProvider>{element}</ThemeProvider>
  </Hel>
)
